const DEFAULT_TITLE = 'Spotahome';
const FIRST_PAGE = 1;

const getTitle = title =>
  title ? `${title} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;

const formatRef = id => `(ref: ${id})`;

export const getPageTitleFromSeo = (metadata = {}) => {
  const { title } = metadata.basic || {};
  return getTitle(title);
};

export const getPageTitleFromSeoForStructuredData = (metadata = {}) => {
  const { title } = metadata?.basic || {};
  return title || DEFAULT_TITLE;
};

export const getSearchPageTitle = (
  metadata = {},
  page = FIRST_PAGE,
  city,
  cityName
) => {
  const { title } = metadata?.basic || {};

  if (!title) {
    return DEFAULT_TITLE;
  }

  const composedTitle = page === FIRST_PAGE ? `${title}` : `${title} ${page}`;

  return getTitle(composedTitle).replace(`landingpage.label.${city}`, cityName);
};

export const getPageTitleForRentableUnit = (
  rentableUnitData,
  locale,
  city,
  cityName
) => {
  const { listing, seo, isRoomsAggregator } = rentableUnitData;

  const contents = listing.contents[locale] || listing.contents.en;
  const title =
    (isRoomsAggregator
      ? contents.propertySeoMetaTitle
      : contents.seoMetaTitle) || contents.title;

  const titleWithRef = title
    ? `${title} ${formatRef(listing.id)}`
    : seo.basic.title || '';

  return getTitle(titleWithRef).replace(`landingpage.label.${city}`, cityName);
};

export const getPageDescriptionForRentableUnit = (
  rentableUnitData,
  locale,
  city,
  cityName
) => {
  const { listing, seo } = rentableUnitData;
  const contents = listing.contents[locale] || listing.contents.en;
  const description =
    contents.seoMetaDescription ||
    contents.description ||
    seo.basic.description;

  return description
    ? `${description.replace(
        `landingpage.label.${city}`,
        cityName
      )} ${formatRef(listing.id)}`
    : '';
};

export default {
  getPageTitleFromSeo,
  getSearchPageTitle,
  getPageTitleForRentableUnit,
  getPageDescriptionForRentableUnit
};
